import { useQuery } from '@apollo/client';
import { useIntl } from 'react-intl';

import type { ProductType } from '@xing-com/crate-common-graphql-types';
import { GetCampaignDocument } from '@xing-com/crate-upsell-graphql';

import { StyledMarker } from '../header/header.styled';

type DiscountBadgeProps = {
  product: ProductType.Projobs | ProductType.Premium;
};

export const DiscountBadge: React.FC<DiscountBadgeProps> = ({ product }) => {
  const { formatMessage, locale } = useIntl();
  const { loading, error, data } = useQuery(GetCampaignDocument, {
    variables: { product, language: locale },
  });

  const discount = data?.results?.contracts.reduce((maxDiscount, contract) => {
    const { price, initialDuration } = contract;
    const cDiscount = Math.round(
      100 * (1 - price.initial / initialDuration / price.renewal)
    );
    return cDiscount > maxDiscount ? cDiscount : maxDiscount;
  }, 0);

  return !loading && !error && discount ? (
    <StyledMarker variant="strong" data-testid="current-upsell-discount">
      {formatMessage(
        {
          id: 'FRAME_HEADER_UPSELL_DISCOUNT',
        },
        { percentage: discount }
      )}
    </StyledMarker>
  ) : null;
};
